import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IAddressDto, IClient, IGuestUserDto } from 'src/app/core/models';
import { ClientService, ToastService } from 'src/app/core/services';
import { CommonConstants } from 'src/app/shared/constant';

@Component({
  selector: 'ic-guest-login',
  templateUrl: './guest-login.component.html',
  styleUrls: ['./guest-login.component.scss'],
})
export class GuestLoginComponent implements OnInit {
  public formErrors: any = {};
  public guestLoginForm: FormGroup;
  public clientConfig: IClient;
  public address: IAddressDto;
  public deliveryType = CommonConstants.DeliveryType;
  @Input() dialogData: any;

  constructor(
    private readonly fb: FormBuilder,
    private readonly toastService: ToastService,
    private readonly clientService: ClientService,
    public readonly activeDialog: NgbActiveModal
  ) {
    this.clientConfig = this.clientService.currentClientValue;
  }

  ngOnInit(): void {
    this.guestLoginForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(50)]],
      mobile: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/^(?![01])\d{10}$/)
        ],
      ],
      email: [
        '',
        [Validators.required, Validators.maxLength(100), Validators.email],
      ],
      address: [''],
      apartmentNo: ['']
    });

    // This forces validation.
    Object.keys(this.guestLoginForm.controls).forEach((key) => {
      this.guestLoginForm.get(key).markAsTouched();
    });

    this.guestLoginForm.valueChanges.subscribe((changes) => {
      Object.keys(changes).forEach((controlName) => {
        const control = this.guestLoginForm.controls[controlName];
        this.formErrors[controlName] =
          (control.touched || control.dirty) && control.errors ? 'error' : null;
      });
    });

    if (this.dialogData) {
      if (this.dialogData.deliveryType === this.deliveryType.Pickup) {
        this.guestLoginForm.get('address').clearValidators();
        this.guestLoginForm.get('address').updateValueAndValidity();
      } else if (this.dialogData.deliveryType === this.deliveryType.Delivery) {
        this.guestLoginForm
          .get('address')
          .patchValue(this.dialogData?.address?.address);
      }
    }
  }

  get fc() {
    return this.guestLoginForm.controls;
  }

  closeDialog() {
    this.activeDialog.close();
  }

  isNumber(evt: any) {
    evt = evt ? evt : window.event;
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }

  guestLogin() {
    const model: IGuestUserDto | any = {
      ...this.guestLoginForm.value,
    };
    //model.mobile = model.mobile.replace(/\D/g, '');

    this.activeDialog.close(model);
  }

  trimEmail() {
    const val = this.guestLoginForm.get('email').value.trim();
    this.guestLoginForm.get('email').setValue(val);
  }

}
